import { render, staticRenderFns } from "./roleForm.vue?vue&type=template&id=1e343d90&scoped=true"
import script from "./roleForm.vue?vue&type=script&lang=js"
export * from "./roleForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e343d90",
  null
  
)

export default component.exports